import { eventConfig } from "../config/event";
import type { SubmitEntryPayload, SubmitEntryResponse } from "../types";

const endpoint = import.meta.env.VITE_SUBMIT_ENDPOINT as string | undefined;

function mockResponse(payload: SubmitEntryPayload): SubmitEntryResponse {
  const code = `PREVIEW${payload.firstName.slice(0, 3).toUpperCase()}`;
  return {
    status: "created",
    entryAccepted: true,
    entrantId: "local-preview",
    terpeneResult: payload.terpeneResult ?? null,
    productMatch: payload.productMatch ?? null,
    referralUrl: `${eventConfig.landingUrl}?quiz=1&ref=${code}`,
    baseEntries: 1,
    bonusEntries: 0,
    totalEntries: 1,
    emailSync: "not-configured",
  };
}

export async function submitEntry(payload: SubmitEntryPayload): Promise<SubmitEntryResponse> {
  if (!endpoint) {
    if (import.meta.env.DEV) {
      await new Promise((resolve) => window.setTimeout(resolve, 320));
      return mockResponse(payload);
    }
    throw new Error("Entry service is not configured. Please ask the Root to Rise team for help.");
  }

  const response = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = (await response.json().catch(() => null)) as (SubmitEntryResponse & { error?: string }) | null;
  if (!response.ok || !data) {
    throw new Error(data?.error || "We could not submit your entry. Please try again.");
  }
  return data;
}
